import ComponentLink from '../../application-core/ComponentLink';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Typography } from '@material-ui/core';
import { getComponents } from '../../core/utils/utils';

class ComponentLinkList extends Component {

  render() {

    const { defaultLang, graph, data, context, includeIsDefinedBy } = this.props;
    const ontologies = getComponents(data, includeIsDefinedBy, true);
    const displayComponents = context && ontologies.length === 1 && ontologies[0] === context ?
      false
      :
      true;

    if (!displayComponents) return null;

    return (
      <div>
        {ontologies &&
          <div>
            {ontologies.map((component, index) => {
              // Don't display if only one component and this in in that
              if (index < 2 || (index < 3 && ontologies.length === 3)) {
                return <ComponentLink
                  key={component}
                  id={component}
                  handleNotAvailable={true}
                  graph={graph}
                  margin={true}
                  defaultLang={defaultLang} />;
              }
              else return null;
            })}
            {ontologies.length > 3 &&
              <Typography
                data-test="too-many-ontologies"
                variant="caption"
                style={{ marginLeft: 20, marginTop: 4 }}>Additional ontologies were also found ({ontologies.length - 2}).</Typography>
            }
          </div>
        }
      </div>
    );
  }

}

ComponentLinkList.defaultProps = {
  includeIsDefinedBy: false
};

ComponentLinkList.propTypes = {
  context: PropTypes.string,
  includeIsDefinedBy: PropTypes.bool,
  graph: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default ComponentLinkList;